import { Injectable } from "@angular/core";
import { CacheManager } from "src/app/cache/cache-manager";
import { StateDataRepository } from "../repositories/state-data.repository";
import { StoredStateData } from "src/app/driver/storage/models/stored-state-data";

/**
 * Provides a cache manager for the state data repository.
 * This prevents multiple simultaneous requests from the UI from repeatedly
 * querying the database for the same state data.
 * 
 * Direct use of the StateDataRepository should be avoided and all access to state data should go through this cache manager.
 */
@Injectable({
	providedIn: 'root'
})
export class StateDataRepositoryCacheManager extends CacheManager<StoredStateData> {

	/**
	 * @constructor
	 *
	 * @param stateDataRepository Repository used to interact with the state data.
	 */
	constructor(
		stateDataRepository: StateDataRepository
	) {
		super(stateDataRepository);
	}
}